const PauseModal = ({ isOpen, onNo, onYes }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-start pt-30 justify-center z-[999]">
      <div className="bg-white md:w-[720px] rounded-[6px] p-2">

        <h2 className="text-[18px] font-[500] text-[#333333] mb-6  pl-4 pt-4">
          Do you want to pause the test?
        </h2>

        <div className="flex justify-end gap-4">
          <button
            onClick={onNo}
            className="px-5 py-2 text-[#333333] font-[500] text-[18px] "
          >
            No
          </button>

          <button
            onClick={onYes}
            className="px-5 py-2 bg-[#4096F6] font-[500] text-[18px] text-white rounded-[4px]"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default PauseModal;
